"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImplementationCommonDocument = void 0;
const common_1 = require("../../common");
const enums_1 = require("../enums");
class ProductImplementationCommonDocument extends common_1.MongoDocument {
}
exports.ProductImplementationCommonDocument = ProductImplementationCommonDocument;
//# sourceMappingURL=product-implementation-common-document.model.js.map